import React, { useState, useEffect, useRef, useCallback } from "react";
import { Galleria } from "primereact/galleria";
import { URLS } from "../Url";

export default function GallerySection({ images }) {
  const galleriaRef = useRef(null);
  const [activeGal,  setActiveGal]  = useState(0);

  const galItem  = useCallback(item => <img src={URLS.Base + item.image} alt={item.alt} style={{ width:"100%", display:"block" }} />, []);
  const galThumb = useCallback(item => <img src={URLS.Base + item.image} alt={item.alt} style={{ display:"block" }} />, []);

  useEffect(() => {
    const items = document.querySelectorAll(".gal-bento-item");
    const obs = new IntersectionObserver(entries => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = `${i * 0.08}s`;
          e.target.classList.add("in");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, [images]);

  return (
    <section className="cc-sec cc-sec-cream" id="gallery" style={{ overflow:"hidden" }}>
      <div className="container">
        <div className="text-center rv" style={{ marginBottom:56 }}>
          <span className="cc-tag">✦ Gallery ✦</span>
          <h2 className="cc-h">See the <span>Gallery</span> in Action</h2>
          <p className="cc-sub">Real moments captured at CarnivalCastle Private Theatres.</p>
        </div>
        <div className="gal-bento rv">
          {images.map((img, i) => (
            <div key={i} className={`gal-bento-item gbi-${i + 1}`}
              onClick={() => { setActiveGal(i); galleriaRef.current?.show(); }}>
              <img src={URLS.Base + img.image} alt={img.alt || `Gallery ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
        <Galleria ref={galleriaRef} value={images} numVisible={6} style={{ maxWidth:850 }}
          activeIndex={activeGal} onItemChange={e => setActiveGal(e.index)}
          circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb} />
        <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:40, flexWrap:"wrap" }}>
          <a href="/gallery" className="cc-btn">View Full Gallery →</a>
          <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn">
            <i className="bi bi-whatsapp" /> Chat With Us
          </a>
        </div>
      </div>
    </section>
  );
}